import { render, staticRenderFns } from "./Flowchart.vue?vue&type=template&id=18820e15&"
import script from "./Flowchart.vue?vue&type=script&lang=js&"
export * from "./Flowchart.vue?vue&type=script&lang=js&"
import style0 from "./index.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports